import { getAnimateRotationStyle } from '@billy/design-system'
import styled from '@emotion/styled'

export const RotatingIconWrapper = styled.figure`
  display: flex;
  ${getAnimateRotationStyle()};
`
